import React, {useState} from "react";
import style from "./block.module.scss";
import {AdherentModal} from "../modal/Modal"
import {ReactComponent as Arrow} from "../assets/arrow.svg";
import apiFetch from '@wordpress/api-fetch';

export default function AdherentSignupForm({open, setVisibility}) {
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [castle, setCastle] = useState("");

    const [alert, setAlert] = useState();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleChange = event => {
        switch(event.target.name) {
            case "lastname":
                setLastname(event.target.value);
                break;
            case "firstname":
                setFirstname(event.target.value);
                break;
            case "email":
                setEmail(event.target.value);
                break;
            case "phone":
                setPhone(event.target.value);
                break;
            case "castle":
                setCastle(event.target.value);
                break;
            default:
                return;
        }
    };

    const checkForm = () => {
        const emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        
        if(!firstname) {
            setAlert({type: "error", message: "Prénom manquant."})
        }
        else if(!lastname) {
            setAlert({type: "error", message: "Nom manquant."})
        }
        else if(!email || !emailRegex.test(email)) {
            setAlert({type: "error", message: "E-mail manquant ou incorrect."})
        }
        else if(!castle) {
            setAlert({type: "error", message: "Château manquant."})
        }
        else {
            return true;
        }
        return false;
    }

    const sendRequest = async () => {
        setAlert();

        if(!checkForm()) {
            return;
        };

        setLoading(true);

        try {
            apiFetch({
                    path: "/adherent/v1/signup",
                    method: 'POST',
                    data: { firstname, lastname, email, phone, castle },
                })
                .then(data => {
                    setAlert({type: 'success', message: "Demande envoyée."});
                    setLoading(false);
                    setSuccess(true);
                })
                .catch(err => {
                    setAlert({type: 'error', message: "Impossible d'envoyer la demande actuellement."});
                    setLoading(false);
                });
        } catch (e) {
            setAlert({type: 'error', message: "Une erreur est survenue"});
            setLoading(false);
        }
        
    };

    return (
        <AdherentModal open={open} setVisibility={setVisibility}>
                {!success && <div className={style.textBloc}>
                    <h2 className={style.title}>Création de compte</h2>
                    <hr className={style.separator}/>
                    <p className={style.condition}>Veuillez remplir le formulaire ci-dessous</p>
                    
                    <div className={style.formContainer}>
                        <input onChange={handleChange} type="text" name="lastname" placeholder="Nom" />
                        <input onChange={handleChange} type="text" name="firstname" placeholder="Prénom" />
                        <input onChange={handleChange} type="text" name="email" placeholder="E-mail" />
                        <input onChange={handleChange} type="text" name="phone" placeholder="Téléphone" />
                        <input onChange={handleChange} type="text" name="castle" placeholder="Nom du chateau" />
                        {alert && <p className={[style.alert, style[alert.type]].join(" ")} >{alert.message}</p>}
                    </div>

                    <div className={style.loginButtonContainer}>
                        <Arrow className={style.loginIcon}/>
                        <button disabled={loading} className={style.loginButton} onClick={sendRequest}>Envoyer votre demande</button>
                    </div>
                </div>}

                {success && <div className={style.textBloc}>
                    <h2 className={style.title}>Félicitations</h2>
                    <hr className={style.separator}/>
                    <p className={style.condition}>Votre demande de création de compte a bien été envoyée. <br />
                    Vous allez recevoir un email de confirmation pour accéder à votre espace adhérent.</p>
                </div>}
        </AdherentModal>
    )
}